export const genString = (lenght) => Array(lenght).fill("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz").map((x) => x[Math.floor(Math.random() * x.length)]).join("");
